// extracted by mini-css-extract-plugin
export default {"wrapper":"coming-soon_wrapper__-oPcN","text":"coming-soon_text__bH-w6"};